var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNvidiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.125 17.875C4.125 18.9796 5.02043 19.875 6.125 19.875H17.875C18.9796 19.875 19.875 18.9796 19.875 17.875V6.125C19.875 5.02043 18.9796 4.125 17.875 4.125H6.125C5.02043 4.125 4.125 5.02043 4.125 6.125V17.875ZM4.875 6.875C4.875 5.77043 5.77043 4.875 6.875 4.875H17.125C18.2296 4.875 19.125 5.77043 19.125 6.875V17.125C19.125 18.2296 18.2296 19.125 17.125 19.125H6.875C5.77043 19.125 4.875 18.2296 4.875 17.125V6.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16 6.09747H6.8475C6.64859 6.09747 6.45783 6.17649 6.31717 6.31714C6.17652 6.4578 6.0975 6.64856 6.0975 6.84747V17.16C6.0975 17.3589 6.17652 17.5497 6.31717 17.6903C6.45783 17.831 6.64859 17.91 6.8475 17.91H17.16C17.3589 17.91 17.5497 17.831 17.6903 17.6903C17.831 17.5497 17.91 17.3589 17.91 17.16V6.84747C17.91 6.64856 17.831 6.4578 17.6903 6.31714C17.5497 6.17649 17.3589 6.09747 17.16 6.09747ZM17.16 17.16H6.8475V6.84747H17.16V17.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.3V1.875C12.375 1.66789 12.2071 1.5 12 1.5C11.7929 1.5 11.625 1.66789 11.625 1.875V3.3C11.625 3.50711 11.7929 3.675 12 3.675C12.2071 3.675 12.375 3.50711 12.375 3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9775 3.3V1.875C14.9775 1.66789 14.8096 1.5 14.6025 1.5C14.3954 1.5 14.2275 1.66789 14.2275 1.875V3.3C14.2275 3.50711 14.3954 3.675 14.6025 3.675C14.8096 3.675 14.9775 3.50711 14.9775 3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6825 3.3V1.875C9.6825 1.66789 9.5146 1.5 9.3075 1.5C9.10039 1.5 8.9325 1.66789 8.9325 1.875V3.3C8.9325 3.50711 9.10039 3.675 9.3075 3.675C9.5146 3.675 9.6825 3.50711 9.6825 3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8475 3.3V1.875C6.8475 1.66789 6.67961 1.5 6.4725 1.5C6.2654 1.5 6.0975 1.66789 6.0975 1.875V3.3C6.0975 3.50711 6.2654 3.675 6.4725 3.675C6.67961 3.675 6.8475 3.50711 6.8475 3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 3.3V1.875C17.91 1.66789 17.7421 1.5 17.535 1.5C17.3279 1.5 17.16 1.66789 17.16 1.875V3.3C17.16 3.50711 17.3279 3.675 17.535 3.675C17.7421 3.675 17.91 3.50711 17.91 3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 22.125V20.7C12.375 20.4929 12.2071 20.325 12 20.325C11.7929 20.325 11.625 20.4929 11.625 20.7V22.125C11.625 22.3321 11.7929 22.5 12 22.5C12.2071 22.5 12.375 22.3321 12.375 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9775 22.125V20.7C14.9775 20.4929 14.8096 20.325 14.6025 20.325C14.3954 20.325 14.2275 20.4929 14.2275 20.7V22.125C14.2275 22.3321 14.3954 22.5 14.6025 22.5C14.8096 22.5 14.9775 22.3321 14.9775 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6825 22.125V20.7C9.6825 20.4929 9.5146 20.325 9.3075 20.325C9.10039 20.325 8.9325 20.4929 8.9325 20.7V22.125C8.9325 22.3321 9.10039 22.5 9.3075 22.5C9.5146 22.5 9.6825 22.3321 9.6825 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8475 22.125V20.7C6.8475 20.4929 6.67961 20.325 6.4725 20.325C6.2654 20.325 6.0975 20.4929 6.0975 20.7V22.125C6.0975 22.3321 6.2654 22.5 6.4725 22.5C6.67961 22.5 6.8475 22.3321 6.8475 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 22.125V20.7C17.91 20.4929 17.7421 20.325 17.535 20.325C17.3279 20.325 17.16 20.4929 17.16 20.7V22.125C17.16 22.3321 17.3279 22.5 17.535 22.5C17.7421 22.5 17.91 22.3321 17.91 22.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 11.625H20.7C20.4929 11.625 20.325 11.7929 20.325 12C20.325 12.2071 20.4929 12.375 20.7 12.375H22.125C22.3321 12.375 22.5 12.2071 22.5 12C22.5 11.7929 22.3321 11.625 22.125 11.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 14.2275H20.7C20.4929 14.2275 20.325 14.3954 20.325 14.6025C20.325 14.8096 20.4929 14.9775 20.7 14.9775H22.125C22.3321 14.9775 22.5 14.8096 22.5 14.6025C22.5 14.3954 22.3321 14.2275 22.125 14.2275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 8.9325H20.7C20.4929 8.9325 20.325 9.10039 20.325 9.3075C20.325 9.5146 20.4929 9.6825 20.7 9.6825H22.125C22.3321 9.6825 22.5 9.5146 22.5 9.3075C22.5 9.10039 22.3321 8.9325 22.125 8.9325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 6.09003H20.7C20.4929 6.09003 20.325 6.25792 20.325 6.46503C20.325 6.67213 20.4929 6.84003 20.7 6.84003H22.125C22.3321 6.84003 22.5 6.67213 22.5 6.46503C22.5 6.25792 22.3321 6.09003 22.125 6.09003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.125 17.16H20.7C20.4929 17.16 20.325 17.3279 20.325 17.535C20.325 17.7421 20.4929 17.91 20.7 17.91H22.125C22.3321 17.91 22.5 17.7421 22.5 17.535C22.5 17.3279 22.3321 17.16 22.125 17.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 11.625H1.875C1.66789 11.625 1.5 11.7929 1.5 12C1.5 12.2071 1.66789 12.375 1.875 12.375H3.3C3.50711 12.375 3.675 12.2071 3.675 12C3.675 11.7929 3.50711 11.625 3.3 11.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 14.2275H1.875C1.66789 14.2275 1.5 14.3954 1.5 14.6025C1.5 14.8096 1.66789 14.9775 1.875 14.9775H3.3C3.50711 14.9775 3.675 14.8096 3.675 14.6025C3.675 14.3954 3.50711 14.2275 3.3 14.2275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 8.9325H1.875C1.66789 8.9325 1.5 9.10039 1.5 9.3075C1.5 9.5146 1.66789 9.6825 1.875 9.6825H3.3C3.50711 9.6825 3.675 9.5146 3.675 9.3075C3.675 9.10039 3.50711 8.9325 3.3 8.9325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 6.09003H1.875C1.66789 6.09003 1.5 6.25792 1.5 6.46503C1.5 6.67213 1.66789 6.84003 1.875 6.84003H3.3C3.50711 6.84003 3.675 6.67213 3.675 6.46503C3.675 6.25792 3.50711 6.09003 3.3 6.09003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 17.16H1.875C1.66789 17.16 1.5 17.3279 1.5 17.535C1.5 17.7421 1.66789 17.91 1.875 17.91H3.3C3.50711 17.91 3.675 17.7421 3.675 17.535C3.675 17.3279 3.50711 17.16 3.3 17.16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvidiaLogo);
export default __webpack_public_path__ + "static/media/nvidia-logo.36ceab49b5cb30a8ebbd33064df642ae.svg";
export { ForwardRef as ReactComponent };